if (Foundation.MOBILE) {
    /** @implements {Foundation.View.Interface.ModalDialog} */
    Foundation.View.ModalDialog = Foundation.View.Mobile.ModalDialog;
}
else if (Foundation.RESPONSIVE) {
    /** @implements {Foundation.View.Interface.ModalDialog} */
    Foundation.View.ModalDialog = Foundation.View.Responsive.ModalDialog;
}
else {
    /** @implements {Foundation.View.Interface.ModalDialog} */
    Foundation.View.ModalDialog = Foundation.View.Desktop.Fancybox;
}
